import { CreateChequePayload } from '../../types';

export const initialChequeValues: CreateChequePayload = {
  cheque_no: '',
  dr_no: '',
  pdc_date: '',
  liability: 1,
  po_nos: [],
  cheque_img_url: '',
  amount: 0,
  supplier_id: undefined,
  credit_memo_amount: 0
};

export const chequeListParamOrder = [
  'cheque_no',
  'dr_no',
  'liability',
  'pdc_date_from',
  'pdc_date_to',
  'page'
];
